import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class elligableDateValidator {
  static elligableDate(control: AbstractControl): ValidationErrors | null {
    if (!control)
      return null
    let DOB = control.get('birthdate');
    if (DOB == null) {
      DOB = control.get('dateOfBirth');
    }

    if (DOB && DOB.hasError('matDatepickerParse')) {
      if (isNaN(Date.parse(DOB.errors.matDatepickerParse.text)))
        return { invalidDate: true }
    }

    let controlDate = DOB.value ? ((DOB.value instanceof Date) ? DOB.value : (DOB.value._d? DOB.value._d: DOB.value)) : null;

    if (controlDate == null) { return null; }
    const isIndividual = control.get('isIndividual').value;
    if (!isIndividual) { return null; }
    if (controlDate == null || controlDate === '') { return null; }
    if (controlDate instanceof Date) {
      if (isNaN(controlDate.getTime())) {  // d.valueOf() could also work
        //     // date is not valid
        return { invalidDate: true }
        //   } 
      }
    } else {
      if (controlDate.includes('-'))
        controlDate = controlDate.replaceAll('-', '/');
      let dateArray = controlDate.split('/');

      const date = new Date(dateArray[2], (+dateArray[1] - 1), dateArray[0]);

      if ((+dateArray[1] - 1) > 12 || dateArray[0] > 31) {
        return { invalidDate: true }
      }

      const isVisaCustomerControl = control.get('isVisaCustomer');
      const isVisaCustomer = isVisaCustomerControl ? isVisaCustomerControl.value : false;
      if (!isVisaCustomer)
        return (date >= new Date(1300, 1)) ? null : { invalidDate: true };
      else
        return (date <= new Date() ? null : { invalidDate: true })
    }

    // if (Object.prototype.toString.call(date) === "[object Date]") {
    //   // it is a date
    //   if (isNaN(date.getTime())) {  // d.valueOf() could also work
    //     // date is not valid
    //     return { invalidDate: true }
    //   } 

    // } else {
    //   // not a date
    //   return { invalidDate: true }
    // }


  }
}

export class elligableAgeValidator {
  static elligableAge(control: AbstractControl): ValidationErrors | null {
    if (!control)
      return null
    let DOB = control.get('birthdate');
    if (DOB == null)
      DOB = control.get('dateOfBirth');
    const isIndividual = control.get('isIndividual').value;
    if (!isIndividual) { return null; }
    // if ( DOB && (DOB.value == null || DOB.value === '')) { return null; }
    let controlDate = DOB.value ? ((DOB.value instanceof Date) ? DOB.value : (DOB.value._d? DOB.value._d: DOB.value)) : '';
    let isHijri = control.get('isHijri').value;
    const isVisaCustomerControl = control.get('isVisaCustomer');
    const isVisaCustomer = isVisaCustomerControl ? isVisaCustomerControl.value : false;
    if (isHijri) { return null }
    if (isVisaCustomer) { return null }

    let minimumAge = control.get('minimumAge').value;
    const Today = new Date();
    if (controlDate instanceof Date) {
      const actualAge = (Today.getTime() - controlDate.getTime()) / (1000 * 60 * 60 * 24 * 30 * 12);
      return (actualAge >= minimumAge) ? null : { invalidAge: true };
    }
    else if(typeof controlDate  == 'string'){
      if (controlDate.includes('-'))
        controlDate = controlDate.replace(/-/g,'/');
      let dateArray = controlDate.split('/');
      const date = new Date(dateArray[2], (+dateArray[1] - 1), dateArray[0]);
      const actualAge = (Today.getTime() - date.getTime()) / (1000 * 60 * 60 * 24 * 30 * 12);
      return (actualAge >= minimumAge) ? null : { invalidAge: true };
    }
  }
}

export class passwordValidator {
  static passwordMatch(control: AbstractControl): ValidationErrors | null {
    if (!control)
      return null
    let password1 = control.get('password').value;
    let confirmPassword = control.get('confirmPassword').value;

    if (!password1 || !confirmPassword)
      return null;

    if (password1 !== confirmPassword) {
      return { passwordDoesNotMatch: true };
    }
    return null
  }

  static passwordStrength(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null;
    }

    const hasUpperCase = /[A-Z]+/.test(value);

    const hasLowerCase = /[a-z]+/.test(value);

    const hasNumeric = /[0-9]+/.test(value);

    const passwordValid = hasUpperCase && hasLowerCase && hasNumeric;

    return !passwordValid ? { passwordStrength: true } : null;
  }
}

export class FullNameValidator {
  static fullNameLength(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null;
    }

    return value.trim().split(' ').length >= 3 ? null : { fullNameError: true };
  }
}

export function TwoFieldMatchingMatching(dbValue: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || !dbValue) { return null; }

    if (control.value != dbValue) {
      return { valueDoesNotMatch: true };
    }
    return null;
  }
}
